import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';

import { environment } from '@environments/environment';
import { AuthService } from '@app/core/domain/auth';
import { finalize, tap } from 'rxjs/operators';
import { resultDialog } from '../util/alert-handler';
import { DialogType } from '../enum/app.enums';
import { setBearerHeaders } from './http-helper';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private logger: NGXLogger) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!window.navigator.onLine) {
            // if there is no internet, throw a HttpErrorResponse error
            // since an error is thrown, the function will terminate here
            const error = {
                status: 0,
                error: {
                    description: 'Check internet connectivity!',
                },
                statusText: 'Check internet connectivity!',
            };
            resultDialog(DialogType.Error, 'Check internet connectivity!', 'No Internet');
            return throwError(new HttpErrorResponse(error));
        } else {
            // add auth header with jwt if user is logged in and request is to the api url
            const token = this.authService.tokenValue;
            const isLoggedIn = token && token.accessToken;
            const isApiUrl = request.url.startsWith(environment.apiUrl) || request.url.startsWith(environment.apiUrl);
            if (isLoggedIn && isApiUrl) {
                request = request.clone({
                    setHeaders: setBearerHeaders(token.accessToken),
                });
            }

            const started = Date.now();
            let ok: string;

            return next.handle(request).pipe(
                tap(
                    (event: HttpEvent<any>) => (ok = event instanceof HttpResponse ? 'succeeded' : ''),
                    (error: HttpErrorResponse) => (ok = 'failed'),
                ),
                // Log when response observable either completes or errors
                finalize(() => {
                    const elapsed = Date.now() - started;
                    const msg = `${request.method} "${request.urlWithParams}" ${ok} in ${elapsed} ms.`;
                    if (ok !== 'failed') {
                        this.logger.info(msg);
                    } else {
                        this.logger.warn(msg);
                    }
                }),
            );
        }
    }
}
